import { render, staticRenderFns } from "./DispensaValor.vue?vue&type=template&id=f0d9cb6e&"
import script from "./DispensaValor.vue?vue&type=script&lang=js&"
export * from "./DispensaValor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports